import type { IScope } from "angular";

const NEW_LINE_REGEXP = /[\n\r]+/;
const NEW_LINE = "\r\n";
const ENTER_KEY_CODE = 13;

export default class EditInstructionRowsComponentController {
    public static $inject: string[] = ["$scope"];

    public heading: string;

    public instruction: string;

    public instructionRows: string[] = [""];

    public rowsManuallyAdded = false;

    constructor(private readonly $scope: IScope) {}

    public $onInit() {
        const unsub = this.$scope.$watch("$ctrl.instruction", (instruction: string) => {
            if (instruction === undefined) {
                return;
            }

            this.instructionRows = instruction
                .split(NEW_LINE_REGEXP)
                .map((str) => str.trim())
                .filter((str) => str);

            if (!this.instructionRows.length) {
                this.instructionRows.push("");
            }

            unsub();
        });
    }

    public addInstructionRow() {
        this.instructionRows.push("");
        this.rowsManuallyAdded = true;

        this.onInput();
    }

    public removeInstructionRow(index: number) {
        this.instructionRows.splice(index, 1);

        this.onInput();
    }

    public onInput() {
        this.instruction = this.instructionRows
            .map((str) => str.trim())
            .filter((str) => str)
            .join(NEW_LINE);
    }

    public onEnter(event: JQueryEventObject) {
        if (event.which !== ENTER_KEY_CODE) {
            return;
        }

        this.addInstructionRow();
        event.preventDefault();
    }
}
